import { render, staticRenderFns } from "./settingspage.vue?vue&type=template&id=c2822614&"
import script from "./settingspage.vue?vue&type=script&lang=js&"
export * from "./settingspage.vue?vue&type=script&lang=js&"
import style0 from "./settingspage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../usr/local/lib/node_modules/@vue/cli-service-global/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports